// src/portals/fan/pages/TransactionsPage/TransactionsPage.js
import React from "react";
import { useAuth } from "../../../../context/AuthContext";
import PageHeader from "../../components/PageHeader";
import TransactionItem from "./../ProfilePage/components/wallet/TransactionItem";

const TransactionsPage = () => {
  const { currentUser } = useAuth();
  const transactions = currentUser?.wallet?.transactionHistory || [];

  return (
    <div className="flex flex-col h-full bg-slate-50">
      <PageHeader title="Transactions" backTo="/fan/profile" />
      <div className="flex-grow overflow-y-auto p-4 space-y-6">
        <div>
          <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
            {transactions.length > 0 ? (
              transactions.map((tx) => (
                <TransactionItem key={tx.id} transaction={tx} />
              ))
            ) : (
              <p className="p-8 text-center text-slate-500">
                No transactions yet.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionsPage;
